<!-- 
  产品数量超过200时公共弹窗
 -->
<template>
  <v-dialog
    v-model="dialogBol"
    :max-width="maxWidth + 'px'"
    persistent
    :min-height="minHeight + 'px'"
  >
    <v-card class="pa-4 flex1">
      <v-card-text class="pa-0">
        <div class="dialog-cont d-flex pb-5 pt-4">
          <span class="mdi mdi-alert-circle fs-28"></span>
          <p>
            {{ tipStrat }}
            <a :href="`mailto:${infoMailbox}`" target="_blank">{{
              infoMailbox
            }}</a> {{ tipEnd }}
          </p>
        </div>
        <div class="d-flex justify-end">
          <v-btn color="primary" @click="closeFn">Okay</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script setup>
const { $multiPlatform } = useNuxtApp();
const infoMailbox = $multiPlatform.infoMailbox;
const props = defineProps({
  maxWidth: {
    type: Number,
    default: 600
  },
  minHeight: {
    type: Number,
    default: 100
  },
  tipStrat:{
    type: String,
    default:'Thank you for your interest in our products. For large quantity orders, please kindly contact our sales team at'
  },
  tipEnd:{
    type:String,
    default:'to receive a customized quote tailored to your bulk purchasing needs.'
  }
});
const emits = defineEmits(["update:modelValue"]);
const dialogBol = ref(false);
const closeFn = () => {
  emits("update:modelValue", false);
};
</script>
<style lang="scss" scoped>
:deep(.v-overlay__content) {
  height: auto !important;
  top: auto !important;
  left: auto !important;
  border-radius: 5px;
  .dialog-cont {
    .mdi-alert-circle {
      line-height: 28px;
      color: rgba(251, 140, 0, 0.7);
      margin-right: 16px;
    }
    p {
      font-size: 14px;
      line-height: 21px;
      color: rgba(0, 0, 0, 0.6);
      a {
        text-decoration: underline;
      }
    }
  }
}
</style>
